import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { ProductKey, productInfo } from "src/config/config";

export const getProductInfo = (): { key: string; name: string } => {
  const { key, name } =
    productInfo[
      `${getProductFromSessionStorage() ?? "WRAPSODY"}` as ProductKey
    ];
  // const { key, name } = productInfo["WRAPSODY"];
  // console.log("getProductFromSessionStorage", getProductFromSessionStorage());

  return {
    key,
    name,
  };
};
export const checkProduct = (product: string) => {
  return sessionStorage.getItem("product") === product;
};
